import { render } from "./barkaBrand.vue?vue&type=template&id=7ff3bd30&scoped=true"
import script from "./barkaBrand.vue?vue&type=script&lang=js"
export * from "./barkaBrand.vue?vue&type=script&lang=js"

import "./barkaBrand.vue?vue&type=style&index=0&id=7ff3bd30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ff3bd30"]])

export default __exports__